import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AuthenticationStatus, AuthSelector, CoreState, CustomerManagementSelector } from "@obg/ngx.core";
import { combineLatest } from "rxjs";
import { filter, map } from "rxjs/operators";

@Injectable()
export class CustomerConsistencyService {
	readonly consistentCustomer$ = combineLatest([
		this.store.select(CustomerManagementSelector.getCustomer),
		this.store.select(AuthSelector.getAuthenticationStatus),
	]).pipe(
		filter(([customer, status]) =>
			customer ? status === AuthenticationStatus.Authenticated : status === AuthenticationStatus.NotAuthenticated
		),
		map(([customer]) => customer)
	);

	constructor(private store: Store<CoreState>) {}
}
